export const SPORTS = [
  {
    id: 'powerlifting',
    name: 'Powerlifting',
    emoji: '🏋️',
    category: 'Strength',
    energySystem: 'ATP-PCr',
    primaryMuscles: ['quadriceps', 'hamstrings', 'glutes', 'chest', 'upper back'],
    secondaryMuscles: ['core', 'shoulders', 'triceps', 'forearms'],
    keyLifts: ['Barbell Squat', 'Bench Press', 'Deadlift'],
    pexelsQuery: 'powerlifting barbell gym',
    description: 'Compete in squat, bench, deadlift. Maximum strength development.',
    metrics: ['Total (kg)', '1RM Squat', '1RM Bench', '1RM Deadlift', 'Wilks Score'],
  },
  {
    id: 'marathon',
    name: 'Marathon Running',
    emoji: '🏃',
    category: 'Endurance',
    energySystem: 'Aerobic',
    primaryMuscles: ['quadriceps', 'hamstrings', 'calves', 'glutes'],
    secondaryMuscles: ['core', 'hip flexors', 'tibialis anterior'],
    keyLifts: ['Tempo Runs', 'Long Runs', 'Intervals', 'Easy Runs'],
    pexelsQuery: 'marathon runner road race',
    description: '42.2km of pure aerobic endurance. Train your engine.',
    metrics: ['Finish Time', 'Weekly Mileage', 'VO2 Max', 'Lactate Threshold Pace'],
  },
  {
    id: 'crossfit',
    name: 'CrossFit',
    emoji: '⚡',
    category: 'Functional',
    energySystem: 'Mixed',
    primaryMuscles: ['full body', 'posterior chain', 'shoulders'],
    secondaryMuscles: ['core', 'grip', 'calves'],
    keyLifts: ['Clean & Jerk', 'Snatch', 'Thrusters', 'Kipping Pull-ups'],
    pexelsQuery: 'crossfit workout functional fitness',
    description: 'Constantly varied, high intensity functional movements.',
    metrics: ['Fran Time', 'Grace Time', 'Max Clean & Jerk', 'Annie Score'],
  },
  {
    id: 'bodybuilding',
    name: 'Bodybuilding',
    emoji: '💪',
    category: 'Aesthetic',
    energySystem: 'Glycolytic',
    primaryMuscles: ['chest', 'back', 'shoulders', 'biceps', 'triceps', 'quadriceps', 'hamstrings'],
    secondaryMuscles: ['core', 'calves', 'forearms', 'glutes'],
    keyLifts: ['Hypertrophy Splits', 'Isolation Work', 'Compound Movements'],
    pexelsQuery: 'bodybuilding gym physique muscle',
    description: 'Build maximum muscle mass and symmetry. Arnold approved.',
    metrics: ['Body Weight', 'Body Fat %', 'Muscle Measurements', 'Stage Conditioning'],
  },
  {
    id: 'rock_climbing',
    name: 'Rock Climbing',
    emoji: '🧗',
    category: 'Skill',
    energySystem: 'Mixed',
    primaryMuscles: ['forearms', 'lats', 'core', 'finger flexors'],
    secondaryMuscles: ['shoulders', 'biceps', 'legs', 'rotator cuff'],
    keyLifts: ['Dead Hangs', 'Pull-ups', 'Finger Board', 'Campus Board'],
    pexelsQuery: 'rock climbing athlete bouldering',
    description: 'Strength, technique, and mental fortitude on the wall.',
    metrics: ['Redpoint Grade', 'Hangboard Max', 'Pull-up Max', 'Campus Moves'],
  },
  {
    id: 'mma',
    name: 'MMA / Combat Sports',
    emoji: '🥊',
    category: 'Combat',
    energySystem: 'Alactic + Glycolytic',
    primaryMuscles: ['rotational core', 'hips', 'shoulders', 'legs'],
    secondaryMuscles: ['neck', 'forearms', 'calves', 'posterior chain'],
    keyLifts: ['Turkish Get-ups', 'Medicine Ball Slams', 'Sprawls', 'Hip Escapes'],
    pexelsQuery: 'martial arts MMA boxing training',
    description: 'Strike, grapple, dominate. Total athletic development.',
    metrics: ['Striking Power', 'Grappling Endurance', 'VO2 Max', 'Fight Readiness'],
  },
  {
    id: 'cycling',
    name: 'Cycling',
    emoji: '🚴',
    category: 'Endurance',
    energySystem: 'Aerobic',
    primaryMuscles: ['quadriceps', 'hamstrings', 'calves', 'glutes'],
    secondaryMuscles: ['core', 'hip flexors', 'lower back'],
    keyLifts: ['VO2 Max Intervals', 'Threshold Rides', 'Sweet Spot', 'Cadence Drills'],
    pexelsQuery: 'cycling road bike athlete',
    description: 'Power, aerobic capacity, and tactical racing.',
    metrics: ['FTP (watts)', 'W/kg', 'VO2 Max', 'CTL/TSS'],
  },
  {
    id: 'basketball',
    name: 'Basketball',
    emoji: '🏀',
    category: 'Team Sport',
    energySystem: 'Repeated Sprint',
    primaryMuscles: ['quadriceps', 'glutes', 'calves', 'shoulders'],
    secondaryMuscles: ['core', 'forearms', 'hip flexors', 'hamstrings'],
    keyLifts: ['Vertical Jump Training', 'Lateral Shuffle', 'Defensive Slides', 'Plyometrics'],
    pexelsQuery: 'basketball training athlete court',
    description: 'Explosive speed, vertical, and endurance for the court.',
    metrics: ['Vertical Jump', 'Sprint Speed', 'Agility T-Test', 'VO2 Max'],
  },
  {
    id: 'swimming',
    name: 'Swimming',
    emoji: '🏊',
    category: 'Endurance',
    energySystem: 'Aerobic + Glycolytic',
    primaryMuscles: ['shoulders', 'lats', 'triceps', 'core'],
    secondaryMuscles: ['legs', 'glutes', 'forearms', 'rotator cuff'],
    keyLifts: ['Pull-downs', 'Rotator Cuff Work', 'Kick Sets', 'Paddles & Pull Buoy'],
    pexelsQuery: 'swimming pool athlete lanes',
    description: 'Full body endurance sport. Technique meets fitness.',
    metrics: ['100m Split', 'Stroke Rate', 'Distance Per Stroke', 'SWOLF Score'],
  },
  {
    id: 'gymnastics',
    name: 'Gymnastics / Calisthenics',
    emoji: '🤸',
    category: 'Skill',
    energySystem: 'ATP-PCr + Glycolytic',
    primaryMuscles: ['core', 'shoulders', 'chest', 'back'],
    secondaryMuscles: ['hip flexors', 'triceps', 'forearms', 'wrists'],
    keyLifts: ['Ring Rows', 'L-Sit', 'Planche Progressions', 'Bar Muscle-ups'],
    pexelsQuery: 'gymnastics calisthenics bar rings',
    description: 'Master your bodyweight. Strength meets art.',
    metrics: ['L-Sit Hold', 'Planche Level', 'Muscle-up Max', 'Press Handstand'],
  },
  {
    id: 'hiking',
    name: 'Trail Running & Hiking',
    emoji: '🏔️',
    category: 'Outdoor',
    energySystem: 'Aerobic',
    primaryMuscles: ['quadriceps', 'hamstrings', 'calves', 'glutes'],
    secondaryMuscles: ['core', 'hip flexors', 'ankles', 'tibialis'],
    keyLifts: ['Step-ups', 'Single Leg Squats', 'Loaded Carries', 'Box Jumps'],
    pexelsQuery: 'trail running hiking mountains nature',
    description: 'Conquer elevation. Build mountain-ready fitness.',
    metrics: ['Vert Per Hour', 'Trail Pace', 'Elevation Gain', 'Weekly Mileage'],
  },
  {
    id: 'football',
    name: 'Football / Soccer',
    emoji: '⚽',
    category: 'Team Sport',
    energySystem: 'Repeated Sprint',
    primaryMuscles: ['quadriceps', 'hamstrings', 'calves', 'glutes', 'adductors'],
    secondaryMuscles: ['core', 'hip flexors', 'shoulders'],
    keyLifts: ['Sprint Drills', 'Plyometrics', 'Agility Ladders', 'Change of Direction'],
    pexelsQuery: 'soccer football training athlete',
    description: 'Speed, agility, and 90-minute endurance.',
    metrics: ['Sprint Speed', 'Distance Covered', 'Vertical Jump', 'Agility Score'],
  },
];

export const WORKOUT_CATEGORIES = [
  { id: 'fitness', label: 'Fitness', emoji: '🏃', bodyParts: ['cardio', 'waist'] },
  { id: 'bodybuilding', label: 'Bodybuilding', emoji: '💪', bodyParts: ['chest', 'back', 'shoulders', 'upper arms', 'upper legs'] },
  { id: 'yoga', label: 'Yoga', emoji: '🧘', bodyParts: ['waist', 'back', 'chest'] },
  { id: 'hiit', label: 'HIIT', emoji: '⚡', bodyParts: ['cardio', 'waist', 'upper legs'] },
  { id: 'cardio', label: 'Cardio', emoji: '❤️', bodyParts: ['cardio', 'lower legs'] },
  { id: 'mobility', label: 'Mobility', emoji: '🔄', bodyParts: ['back', 'waist', 'neck'] },
];

export const WELLNESS_CATEGORIES = [
  { id: 'yoga', label: 'Yoga Library', emoji: '🧘', desc: 'Morning flow · Power · Yin · Flexibility', tag: '48 classes', tier: 'free' },
  { id: 'meditation', label: 'Meditation', emoji: '🧠', desc: 'Guided · Breathing · Focus sessions', tag: '12 sessions', tier: 'free' },
  { id: 'recovery', label: 'Recovery Protocols', emoji: '🔄', desc: 'Foam rolling · Ice bath · Compression', tag: '20 protocols', tier: 'free' },
  { id: 'sleep', label: 'Sleep Tracker', emoji: '😴', desc: 'Log sleep · AI sleep analysis', tag: 'PRO', tier: 'pro' },
  { id: 'stress', label: 'Stress & HRV', emoji: '💚', desc: 'HRV tracking tips · Journaling prompts', tag: 'PRO', tier: 'pro' },
  { id: 'nutrition', label: 'Mindful Eating', emoji: '🥗', desc: 'Anti-inflammatory · Performance diet', tag: 'ELITE', tier: 'elite' },
];

/** Map sport muscle names to ExerciseDB body parts */
export const MUSCLE_TO_BODY_PART = {
  chest: 'chest',
  back: 'back',
  shoulders: 'shoulders',
  biceps: 'upper arms',
  triceps: 'upper arms',
  quadriceps: 'upper legs',
  hamstrings: 'upper legs',
  glutes: 'upper legs',
  calves: 'lower legs',
  core: 'waist',
  lats: 'back',
  forearms: 'lower arms',
  cardio: 'cardio',
};

export function muscleToBodyPart(muscle) {
  const key = muscle?.toLowerCase().replace(/\s+/g, ' ').trim();
  if (MUSCLE_TO_BODY_PART[key]) return MUSCLE_TO_BODY_PART[key];
  if (key?.includes('chest')) return 'chest';
  if (key?.includes('back') || key?.includes('lat')) return 'back';
  if (key?.includes('shoulder')) return 'shoulders';
  if (key?.includes('quad') || key?.includes('hamstring') || key?.includes('glute')) return 'upper legs';
  if (key?.includes('calf')) return 'lower legs';
  if (key?.includes('core') || key?.includes('waist')) return 'waist';
  return 'chest';
}
